// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"ShowImage__imgBox__vSx9M"};